import { Stack, Typography } from '@mui/material';
import { theme } from 'theme';

const ChatDisclaimer = (): JSX.Element => {
  return (
    <Stack direction="row" alignItems="center" gap={1} py={0.5} borderRadius={1}>
      <Typography variant="caption" color={theme.palette.text.secondary}>
        AI can make mistakes. Check important information.
      </Typography>
    </Stack>
  );
};

export default ChatDisclaimer;
